'use es6';

import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import classNames from 'classnames';

var Code = function Code(props) {
  var className = props.className,
      rest = _objectWithoutProperties(props, ["className"]);

  return React.createElement("code", Object.assign({}, rest, {
    className: classNames(className, 'private-code')
  }));
};

export default Code;
Code.displayName = 'Code';